import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackScimTokenGenerated.meta';

export type UseTrackScimTokenGeneratedParams = {
  is_regenerate: boolean;
  location: 'workspace-settings-security';
};

export const useTrackScimTokenGenerated = () => {
  const { track } = useAnalyticsUtilities();

  const trackScimTokenGenerated = useCallback(
    (params: UseTrackScimTokenGeneratedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackScimTokenGenerated };
};
